import { Button, Divider } from "antd";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthModalContext } from "../../Contexts/AuthModalContext";
import Layout from "../../Components/Layout/Layout";
import MostLikesCategories from "../../Components/MostLikesCategories/MostLikesCategories";
import styles from "./NotFound.module.scss";
import loading_browser from "./images/loading_browser.svg";
import loading_percent from "./images/loading_percent.svg";

const NotFound = () => {
    const { openRegister } = useContext(AuthModalContext);

    return (
        <Layout title="Uh-Oh!">
            <div className="container pt-0 pt-sm-4 pb-5">
                <div className={`${styles.top} d-flex flex-column align-items-center justify-content-center gap-3 p-5 p-sm-0`}>
                    <img src={loading_browser} alt="loading_browser" className="img-fluid" loading="lazy" />
                    <h2 className="text-white text-center mb-0 fw-bold fs-1">Page Under Construction</h2>
                    <p className="text-white text-center fs-3 mb-0">WE ARE LOADING INFORMATION ON THIS PAGE</p>
                    <img src={loading_percent} alt="loading_percent" className="img-fluid" loading="lazy" />
                    <p className="text-white fs-3 mb-0 mt-2">70% ALMOST DONE</p>
                </div>

                <div className={`${styles.cta} d-flex flex-column align-items-center justify-content-center gap-3 pt-5`}>
                    <p className="mb-0 fs-1 fw-bold">Browse the products from other categories</p>
                    <Link to={"/"}>
                        <Button type="primary" className="px-5">
                            Shop Now
                        </Button>
                    </Link>

                    <div className="d-flex gap-2">
                        <div>Not have an account?</div>
                        <span role="button" className="text-primary" onClick={() => openRegister()}>
                            <u className="fw-bold">Register Now</u>
                        </span>
                    </div>
                    <div className="d-flex gap-2">
                        <div>See our</div>
                        <Link to={"/terms-and-condition"} className="text-primary">
                            <u className="fw-bold">Privacy policy</u>
                        </Link>
                    </div>

                    <Divider />
                </div>

                <div className="fs-1 text-primary text-center fw-bold">Shop Now, Make a Difference!</div>

                <div className="mt-3"></div>
                <MostLikesCategories />
            </div>
        </Layout>
    );
};

export default NotFound;
